// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"154240db","240":"f28f45b4","276":"16f47eff","350":"6fa4b761","455":"8766bb00","636":"17c43f27","644":"bd814858","717":"558074e3","895":"5b3d705f","914":"0e5e7f1b","977":"a70630c4"}[chunkId] + ".chunk.js";
};